import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import Progress from '../../../components/pages/Register/Progress'

import {
  selectAccessToken,
  selectRole,
  selectSwitchStep,
} from '../../../routing/fetchingfunction/user/user.reducer'
import { setSwitchStep } from '../../../routing/fetchingfunction/user/user.action'

import { STUDENT_ROLE, studentSwitchSteps, TUTOR_ROLE, tutorSwitchSteps } from '../../../constants'

const Switch = ({ role = STUDENT_ROLE }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const step = useSelector(selectSwitchStep)
  const accessToken = useSelector(selectAccessToken)
  const registerRole = useSelector(selectRole)

  const steps = role === TUTOR_ROLE ? tutorSwitchSteps : studentSwitchSteps

  const handleAddStep = () => {
    if (step >= steps.length) {
      // Redirect after final step
      const redirectPath = role === TUTOR_ROLE ? '/tutor/statistic' : '/student/statistic'
      navigate(redirectPath)
    } else {
      dispatch(setSwitchStep(step + 1))
    }
  }

  const handleContinuePassTheTest = () => dispatch(setSwitchStep(step + 2))

  const getContent = () => {
    if (!Array.isArray(steps) || steps.length === 0 || !steps[step - 1]) {
      return {
        Component: null,
        tabs: [],
      }
    }

    const StepComponent = steps[step - 1].component

    return {
      Component: StepComponent ? (
        <StepComponent
          role={role}
          onAdd={step === 2 ? handleAddStep : undefined}
          onContinue={step === 2 ? handleContinuePassTheTest : undefined}
          onFinalize={step === steps.length ? handleAddStep : undefined}
        />
      ) : null,
      tabs: steps,
    }
  }

  useEffect(() => {
    if (!accessToken || registerRole === role) {
      const redirectPath = role === TUTOR_ROLE ? '/tutor/statistic' : '/student/statistic'
      navigate(redirectPath)
    }
  }, [accessToken, registerRole, role, navigate])

  const { Component, tabs } = getContent()

  return (
    <div className="max-w-screen-xl w-full mx-auto font-Inter h-full text-[#F67443]">
      <Progress step={step} tabs={tabs} tabClassName="!w-1/3" />
      {Component}
    </div>
  )
}

export default Switch
